<ng-container [formGroup]="form">
   <mat-form-field>
      <mat-label>{{ label ?? 'Time Zone' }}</mat-label>
      <input
         autocomplete="off"
         formControlName="value"
         type="text"
         [lcsSingleSelect]="timeZoneSel"
         ndtTimeZoneSelect
         #inputEl
      />
      <ndt-time-zone-select [isIncludeEmptyOption]="true" #timeZoneSel></ndt-time-zone-select>
   </mat-form-field>
</ng-container>
